module.exports = __webpack_public_path__ + "assets/202509252035/img/catalogOrganization.74d1bae4.png";